import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import peerAnalysisService from '../../../store/peerAnalysisService'

export const getOwnershipAndGroup = createAsyncThunk(
  'companyAnalysis/peerAnalysis/getOwnershipAndGroup',
  async (params, { rejectWithValue }) => {
    try {
      const res = await peerAnalysisService.getOwnershipAndGroup(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)
